export const Constants = {
  dbTypes: {
    COMPANY: "Company",
    PERIOD: "period",
    PLAN_DETAILS: "plan_details",
    COMPANY_SETTINGS: "CompanySettings",
    BLACK_SCHOLES: "black_scholes",
    CONTRIBUTION: "contribution",
    MODIFICATION: "modification",
    USER: "User",
    IMPORTS: "imports",
    OFFERING_PERIOD: "offering_period",
    PRE_REGISTER: "Preregister",
    REPORT: "report",
    SUMMARY: "summary",
    STOCK_PRICES: "stock_prices",
    OFFERING_PERIOD_CONTRIBUTIONS: "offering_period_contributions",
    PAYMENT_TOKEN: "paymenttoken",
    PLAID_TOKEN: "plaid-token",
    TRANSACTION: "transaction",
    ACCOUNT: "account",
    AUTOPAY: "autopay",
    ACCOUNTSUMMARY: "account_summary",
    FILE: 'file_signedurl',
    APPROVAL_REQUEST: 'approval_request',
    CHANGE_EMAIL: 'change_email',
  },
  dbKeys: {
    STANDARD: "Standard",
    GSI1: "GSI1",
  },
  dbAction: {
    CREATE: "Create",
    UPDATE: "Update",
    DELETE: "Delete",
    GET: "Get",
    LIST: "List",
  },
  ADMIN_COMPANY: {
    id: "TaablAdmin",
    name: "Taabl Admin",
    code: "no_code",
    domain: "taabl.co",
  },
  DATEFORMAT: {
    YYYYMMDD: "YYYY-MM-DD",
    MMDDYYYY: "MM/DD/YYYY",
    MDYYYY: "M/D/YYYY",
    MMDYYYY: "MM/D/YYYY",
    MDDYYYY: "M/DD/YYYY",
    MMDDYY: "MM/DD/YY",
    DDMMYYYY: "DD/MM/YYYY",
    MMDDYYYYHH: "MM/DD/YYYY h:mm A",
    DDMMMYY: "DD MMM YY",
    MMDDYYYYHHMM: "DD/MM/YYYY h:mm",
    MONYYYY: "MMM YYYY",
    MONYY: "MMM YY",
    MON: "MMM",
  },
  PROFITSHARE: {
    TAABL: 33,
    EMPLOYEE: 67,
  },
  PermissionLevel: {
    EVERYONE: 0,
    ADMIN: 200,
    TAABL_ADMIN: 3000,
    UNABLE: 999999,
  },
  CONTRIBUTION_STATUS: {
    NEW: "new",
    WITHDRAW: "withdraw",
    TERMINATE: "terminate",
    INCREASE: "increase",
    DECREASE: "decrease",
    RESET: "reset",
    RESET_NEW: "reset_new",
  },
  PERIOD_DISPLAY_TYPES: {
    CONTRIBUTION: "Offering Period",
    CURRENT: "Current Period",
    PURCHASE: "Purchase",
    PREVIOUS: "Previous Period",
  },
  PURCHASE_PERIOD_DISPLAY_TYPES: {
    PURCHASE: "Purchase Period",
    CURRENT: "Current Period",
    PREVIOUS: "Previous Period",
  },
  ESPP_CONTRIBUTION_TYPE: {
    PERCENT: "percent_only",
    DOLLAR: "dollar_only",
    BOTH: "both_one_required",
  },
  ESPP_PURCHASE_TYPE: {
    PERCENT: "percent_only",
    DOLLAR: "dollar_only",
    BOTH: "both_one_required",
  },
  SUMMARY_TYPE: {
    PEOPLE: "people",
    EXPENSE: "expense",
    SHARE_RESERVE: "share_reserve",
    PEOPLE_CONTRIBUTIONS: "people_contributions",
  },
  TaablAdminCompany: "TaablAdmin",
  Default_FAQ_Link:
    "https://en.wikipedia.org/wiki/Employee_stock_purchase_plan",
  PERIOD_TYPES: {
    CURRENT_PERIOD: "currentPeriod",
    LAST_PERIOD: "lastPeriod",
    CURRENT_MONTH: "curentMonth",
    LAST_MONTH: "lastMonth",
    CURRENT_QUARTER: "currentQuarter",
    LAST_QUARTER: "lastQuarter",
    CURRENT_ANNUAL: "currentAnnual",
    LAST_ANNUAL: "lastAnnual",
  },
  DAYS_IN_YEAR: 365,
  MONTH_PER_YEAR: 12,
  FEE_RATE: 6,
  TAX_RATE: 10,
  SESSION_TIMEOUT_IN_HOURS: 1,
  REPAY_LOAN_WITHIN_DAYS: 5,
  PASSWORD_LENGTH: 12,
  DWOLLA_LINKS: {
    TOS: "https://www.dwolla.com/legal/tos/",
    PRIVACY: "https://www.dwolla.com/legal/privacy/",
  },
  DWOLLA_CUSTOMER_STATUS: {
    IN_PROGRESS: "inprogress",
    UNVERIFIED: "unverified",
    VERIFIED: "verified",
    REVERIFICATION: "retry",
    SUSPENDED: "suspended",
    DOCUMENT: "document",
  },
  DWOLLA_TRANSACTION_STATUS: {
    PENDING: "pending",
    PROCESSED: "processed",
    FAILED: "failed",
  },
  EVENT_TYPES: {
    PERSONAL: "signup_personal_info",
    ADDRESS: "signup_address_info",
    PASSWORD: "signup_password_info",
    SIGNUP_DONE: "signup_successful",
    CONNECT_BANK: "connect_bank_info",
    ACCEPT_TERMS: "accept_terms_info",
    BANK_ACCOUNT: "bank_account_info",
    ACCOUNT_VERIFIED: "bank_account_verified",
    PAYSTUB_UPLOADED: "paystub_uploaded",
  }
};
